var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/esnext.global-this.js");

(function (a, b) {
  "object" == typeof exports && "undefined" != typeof module ? b(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], b) : (a = a || self, b(a["react-gradient"] = {}, a.React));
})(this, function (a, b) {
  'use strict';

  var F = Math.PI,
      G = Math.floor,
      H = Math.max,
      I = Math.min,
      J = Math.round;

  function c(a, b) {
    if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
  }

  function d(a, b) {
    for (var c, d = 0; d < b.length; d++) {
      c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
    }
  }

  function e(a, b, c) {
    return b && d(a.prototype, b), c && d(a, c), a;
  }

  function f(a, b, c) {
    return b in a ? Object.defineProperty(a, b, {
      value: c,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : a[b] = c, a;
  }

  function g(a, b) {
    var c = Object.keys(a);

    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(a);
      b && (d = d.filter(function (b) {
        return Object.getOwnPropertyDescriptor(a, b).enumerable;
      })), c.push.apply(c, d);
    }

    return c;
  }

  function h(a) {
    for (var b, c = 1; c < arguments.length; c++) {
      b = null == arguments[c] ? {} : arguments[c], c % 2 ? g(b, !0).forEach(function (c) {
        f(a, c, b[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : g(b).forEach(function (c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
      });
    }

    return a;
  }

  function i(a, b) {
    if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(b && b.prototype, {
      constructor: {
        value: a,
        writable: !0,
        configurable: !0
      }
    }), b && k(a, b);
  }

  function j(a) {
    return j = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
      return a.__proto__ || Object.getPrototypeOf(a);
    }, j(a);
  }

  function k(a, b) {
    return k = Object.setPrototypeOf || function (a, b) {
      return a.__proto__ = b, a;
    }, k(a, b);
  }

  function l(a, b) {
    if (null == a) return {};
    var c,
        d,
        e = {},
        f = Object.keys(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
    }

    return e;
  }

  function m(a, b) {
    if (null == a) return {};
    var c,
        d,
        e = l(a, b);

    if (Object.getOwnPropertySymbols) {
      var f = Object.getOwnPropertySymbols(a);

      for (d = 0; d < f.length; d++) {
        c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
      }
    }

    return e;
  }

  function n(a) {
    if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }

  function o(a, b) {
    return b && ("object" == typeof b || "function" == typeof b) ? b : n(a);
  }

  function p(a, b) {
    return q(a) || r(a, b) || s();
  }

  function q(a) {
    if (Array.isArray(a)) return a;
  }

  function r(a, b) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }

  function s() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function t(a, b) {
    var c = a.length - 1;
    return "parallel" === b ? a.map(function (b, d) {
      var e = a[d],
          f = d === c ? a[0] : a[d + 1],
          g = e[0].map(function (a, b) {
        return a - f[0][b];
      }),
          h = e[1].map(function (a, b) {
        return a - f[1][b];
      });
      return {
        sourceGradient: e,
        leftDelta: g,
        rightDelta: h
      };
    }) : a.map(function (b, d) {
      var e = a[d],
          f = d === c ? a[0] : a[d + 1],
          g = d + 1 === c ? a[0] : d === c ? a[1] : a[d + 2],
          h = [e, f],
          i = [f, g],
          j = h[0].map(function (a, b) {
        return a - i[0][b];
      }),
          k = h[1].map(function (a, b) {
        return a - i[1][b];
      });
      return {
        sourceGradient: h,
        leftDelta: j,
        rightDelta: k
      };
    });
  }

  function u(a) {
    var b = a.sourceGradient,
        c = a.gradientType,
        d = a.rightDelta,
        e = a.leftDelta,
        f = a.duration,
        g = a.property,
        h = a.counter,
        i = a.angle,
        j = +(100 * h / f).toFixed(2),
        k = e.map(L, j),
        l = d.map(L, j),
        m = b[0].map(M, k),
        n = b[1].map(M, l),
        o = "rgb(".concat(m, "), rgb(").concat(n, ")");
    return "".concat(c, "-gradient(").concat(i).concat(o, ")").concat("borderImage" === g ? " 1" : "");
  }

  function v(a, b) {
    return Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2);
  }

  function w() {
    var a = {},
        b = Object.keys(S);

    for (var _c = b.length, _d = 0; _d < _c; _d++) {
      a[b[_d]] = {
        distance: -1,
        parent: null
      };
    }

    return a;
  }

  function x(a) {
    var b = w(),
        c = [a];

    for (b[a].distance = 0; c.length;) {
      var _a = c.pop(),
          _d2 = Object.keys(S[_a]);

      for (var _e = _d2.length, _f = 0; _f < _e; _f++) {
        var _e2 = _d2[_f],
            _g = b[_e2];
        -1 === _g.distance && (_g.distance = b[_a].distance + 1, _g.parent = _a, c.unshift(_e2));
      }
    }

    return b;
  }

  function y(a, b) {
    return function (c) {
      return b(a(c));
    };
  }

  function z(a, b) {
    var c = [b[a].parent, a];
    var d = S[b[a].parent][a],
        e = b[a].parent;

    for (; b[e].parent;) {
      c.unshift(b[e].parent), d = y(S[b[e].parent][e], d), e = b[e].parent;
    }

    return d.conversion = c, d;
  }

  function A(a) {
    var b = function b() {
      for (var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++) {
        b[_key] = arguments[_key];
      }

      var c = b[0];
      return void 0 === c || null === c ? c : (1 < c.length && (b = c), a(b));
    };

    return "conversion" in a && (b.conversion = a.conversion), b;
  }

  function B(a) {
    var b = function b() {
      for (var _len2 = arguments.length, b = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        b[_key2] = arguments[_key2];
      }

      var c = b[0];
      if (void 0 === c || null === c) return c;
      1 < c.length && (b = c);
      var d = a(b);
      if ("object" == typeof d) for (var _a2 = d.length, _b = 0; _b < _a2; _b++) {
        d[_b] = J(d[_b]);
      }
      return d;
    };

    return "conversion" in a && (b.conversion = a.conversion), b;
  }

  function C(a) {
    return null == a ? void 0 === a ? "[object Undefined]" : "[object Null]" : ka && ka in Object(a) ? ga(a) : ja(a);
  }

  function D(a, b, c, d, e) {
    var f = -1,
        g = a.length;

    for (c || (c = va), e || (e = []); ++f < g;) {
      var h = a[f];
      0 < b && c(h) ? 1 < b ? D(h, b - 1, c, d, e) : X(e, h) : !d && (e[e.length] = h);
    }

    return e;
  }

  function E(a, b) {
    var c = a.map(function (a) {
      return a.map(Ta);
    });
    return "parallel" === b ? c : wa(c);
  }

  var K = "default" in b ? b["default"] : b,
      L = function L(a) {
    return this * a / 100;
  },
      M = function M(a, b) {
    return J(a - this[b]);
  },
      N = {
    background: "backgroundImage",
    border: "borderImage",
    text: "backgroundImage"
  },
      O = function O(a) {
    return N[a];
  },
      P = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  };

  var Q = {};

  for (var _i = 0, _Object$keys = Object.keys(P); _i < _Object$keys.length; _i++) {
    var _c2 = _Object$keys[_i];
    Q[P[_c2]] = _c2;
  }

  var R = {
    rgb: {
      channels: 3,
      labels: "rgb"
    },
    hsl: {
      channels: 3,
      labels: "hsl"
    },
    hsv: {
      channels: 3,
      labels: "hsv"
    },
    hwb: {
      channels: 3,
      labels: "hwb"
    },
    cmyk: {
      channels: 4,
      labels: "cmyk"
    },
    xyz: {
      channels: 3,
      labels: "xyz"
    },
    lab: {
      channels: 3,
      labels: "lab"
    },
    lch: {
      channels: 3,
      labels: "lch"
    },
    hex: {
      channels: 1,
      labels: ["hex"]
    },
    keyword: {
      channels: 1,
      labels: ["keyword"]
    },
    ansi16: {
      channels: 1,
      labels: ["ansi16"]
    },
    ansi256: {
      channels: 1,
      labels: ["ansi256"]
    },
    hcg: {
      channels: 3,
      labels: ["h", "c", "g"]
    },
    apple: {
      channels: 3,
      labels: ["r16", "g16", "b16"]
    },
    gray: {
      channels: 1,
      labels: ["gray"]
    }
  };
  var S = R;

  for (var _i2 = 0, _Object$keys2 = Object.keys(R); _i2 < _Object$keys2.length; _i2++) {
    var _c3 = _Object$keys2[_i2];
    if (!("channels" in R[_c3])) throw new Error("missing channels property: " + _c3);
    if (!("labels" in R[_c3])) throw new Error("missing channel labels property: " + _c3);
    if (R[_c3].labels.length !== R[_c3].channels) throw new Error("channel and label counts mismatch: " + _c3);
    var _R$_c = R[_c3],
        _a3 = _R$_c.channels,
        _b2 = _R$_c.labels;
    delete R[_c3].channels, delete R[_c3].labels, Object.defineProperty(R[_c3], "channels", {
      value: _a3
    }), Object.defineProperty(R[_c3], "labels", {
      value: _b2
    });
  }

  R.rgb.hsl = function (a) {
    var c = a[0] / 255,
        d = a[1] / 255,
        e = a[2] / 255,
        b = I(c, d, e),
        f = H(c, d, e),
        g = f - b;
    var i, j;
    f === b ? i = 0 : c === f ? i = (d - e) / g : d === f ? i = 2 + (e - c) / g : e === f && (i = 4 + (c - d) / g), i = I(60 * i, 360), 0 > i && (i += 360);
    var k = (b + f) / 2;
    return j = f === b ? 0 : .5 >= k ? g / (f + b) : g / (2 - f - b), [i, 100 * j, 100 * k];
  }, R.rgb.hsv = function (a) {
    var c, d, e, f, i;

    var j = a[0] / 255,
        k = a[1] / 255,
        g = a[2] / 255,
        b = H(j, k, g),
        l = b - I(j, k, g),
        m = function m(a) {
      return (b - a) / 6 / l + 1 / 2;
    };

    return 0 === l ? (f = 0, i = 0) : (i = l / b, c = m(j), d = m(k), e = m(g), j === b ? f = e - d : k === b ? f = 1 / 3 + c - e : g === b && (f = 2 / 3 + d - c), 0 > f ? f += 1 : 1 < f && (f -= 1)), [360 * f, 100 * i, 100 * b];
  }, R.rgb.hwb = function (a) {
    var c = a[0],
        d = a[1];
    var e = a[2];
    var f = R.rgb.hsl(a)[0],
        g = 1 / 255 * I(c, I(d, e));
    return e = 1 - 1 / 255 * H(c, H(d, e)), [f, 100 * g, 100 * e];
  }, R.rgb.cmyk = function (a) {
    var c = a[0] / 255,
        d = a[1] / 255,
        e = a[2] / 255,
        b = I(1 - c, 1 - d, 1 - e);
    return [100 * ((1 - c - b) / (1 - b) || 0), 100 * ((1 - d - b) / (1 - b) || 0), 100 * ((1 - e - b) / (1 - b) || 0), 100 * b];
  }, R.rgb.keyword = function (a) {
    var b = Q[a];
    if (b) return b;
    var c,
        d = 1 / 0;

    for (var _i3 = 0, _Object$keys3 = Object.keys(P); _i3 < _Object$keys3.length; _i3++) {
      var _b3 = _Object$keys3[_i3];

      var _e3 = P[_b3],
          _f2 = v(a, _e3);

      _f2 < d && (d = _f2, c = _b3);
    }

    return c;
  }, R.keyword.rgb = function (a) {
    return P[a];
  }, R.rgb.xyz = function (a) {
    var c = a[0] / 255,
        d = a[1] / 255,
        e = a[2] / 255;
    c = .04045 < c ? Math.pow((c + .055) / 1.055, 2.4) : c / 12.92, d = .04045 < d ? Math.pow((d + .055) / 1.055, 2.4) : d / 12.92, e = .04045 < e ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92;
    var f = .4124 * c + .3576 * d + .1805 * e,
        h = .2126 * c + .7152 * d + .0722 * e,
        i = .0193 * c + .1192 * d + .9505 * e;
    return [100 * f, 100 * h, 100 * i];
  }, R.rgb.lab = function (c) {
    var d = R.rgb.xyz(c);
    var e = d[0],
        f = d[1],
        g = d[2];
    e /= 95.047, f /= 100, g /= 108.883, e = .008856 < e ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, f = .008856 < f ? Math.pow(f, 1 / 3) : 7.787 * f + 16 / 116, g = .008856 < g ? Math.pow(g, 1 / 3) : 7.787 * g + 16 / 116;
    var h = 116 * f - 16,
        i = 500 * (e - f),
        a = 200 * (f - g);
    return [h, i, a];
  }, R.hsl.rgb = function (a) {
    var b = a[0] / 360,
        c = a[1] / 100,
        d = a[2] / 100;
    var e, f, g;
    if (0 === c) return g = 255 * d, [g, g, g];
    e = .5 > d ? d * (1 + c) : d + c - d * c;
    var h = 2 * d - e,
        j = [0, 0, 0];

    for (var _c4 = 0; 3 > _c4; _c4++) {
      f = b + 1 / 3 * -(_c4 - 1), 0 > f && f++, 1 < f && f--, g = 1 > 6 * f ? h + 6 * (e - h) * f : 1 > 2 * f ? e : 2 > 3 * f ? h + 6 * ((e - h) * (2 / 3 - f)) : h, j[_c4] = 255 * g;
    }

    return j;
  }, R.hsl.hsv = function (a) {
    var b = a[0];
    var c = a[1] / 100,
        d = a[2] / 100,
        e = c;
    var f = H(d, .01);
    d *= 2, c *= 1 >= d ? d : 2 - d, e *= 1 >= f ? f : 2 - f;
    var g = (d + c) / 2,
        h = 0 === d ? 2 * e / (f + e) : 2 * c / (d + c);
    return [b, 100 * h, 100 * g];
  }, R.hsv.rgb = function (a) {
    var b = a[0] / 60,
        c = a[1] / 100;
    var d = a[2] / 100;
    var e = G(b) % 6,
        g = b - G(b),
        f = 255 * d * (1 - c),
        h = 255 * d * (1 - c * g),
        i = 255 * d * (1 - c * (1 - g));
    return d *= 255, 0 == e ? [d, i, f] : 1 == e ? [h, d, f] : 2 == e ? [f, d, i] : 3 == e ? [f, h, d] : 4 == e ? [i, f, d] : 5 == e ? [d, f, h] : void 0;
  }, R.hsv.hsl = function (a) {
    var b = a[0],
        c = a[1] / 100,
        d = a[2] / 100,
        e = H(d, .01);
    var f, g;
    g = (2 - c) * d;
    var h = (2 - c) * e;
    return f = c * e, f /= 1 >= h ? h : 2 - h, f = f || 0, g /= 2, [b, 100 * f, 100 * g];
  }, R.hwb.rgb = function (a) {
    var c = a[0] / 360;
    var d = a[1] / 100,
        e = a[2] / 100;
    var h = d + e;
    var j;
    1 < h && (d /= h, e /= h);
    var k = G(6 * c),
        i = 1 - e;
    j = 6 * c - k, 0 != (1 & k) && (j = 1 - j);
    var l = d + j * (i - d);
    var m, n, o;

    switch (k) {
      default:
      case 6:
      case 0:
        m = i, n = l, o = d;
        break;

      case 1:
        m = l, n = i, o = d;
        break;

      case 2:
        m = d, n = i, o = l;
        break;

      case 3:
        m = d, n = l, o = i;
        break;

      case 4:
        m = l, n = d, o = i;
        break;

      case 5:
        m = i, n = d, o = l;
    }

    return [255 * m, 255 * n, 255 * o];
  }, R.cmyk.rgb = function (a) {
    var d = a[0] / 100,
        c = a[1] / 100,
        e = a[2] / 100,
        f = a[3] / 100,
        h = 1 - I(1, d * (1 - f) + f),
        i = 1 - I(1, c * (1 - f) + f),
        g = 1 - I(1, e * (1 - f) + f);
    return [255 * h, 255 * i, 255 * g];
  }, R.xyz.rgb = function (a) {
    var c = a[0] / 100,
        d = a[1] / 100,
        e = a[2] / 100;
    var f, h, i;
    return f = 3.2406 * c + -1.5372 * d + -.4986 * e, h = -.9689 * c + 1.8758 * d + .0415 * e, i = .0557 * c + -.204 * d + 1.057 * e, f = .0031308 < f ? 1.055 * Math.pow(f, 1 / 2.4) - .055 : 12.92 * f, h = .0031308 < h ? 1.055 * Math.pow(h, 1 / 2.4) - .055 : 12.92 * h, i = .0031308 < i ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, f = I(H(0, f), 1), h = I(H(0, h), 1), i = I(H(0, i), 1), [255 * f, 255 * h, 255 * i];
  }, R.xyz.lab = function (c) {
    var d = c[0],
        e = c[1],
        f = c[2];
    d /= 95.047, e /= 100, f /= 108.883, d = .008856 < d ? Math.pow(d, 1 / 3) : 7.787 * d + 16 / 116, e = .008856 < e ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, f = .008856 < f ? Math.pow(f, 1 / 3) : 7.787 * f + 16 / 116;
    var g = 116 * e - 16,
        h = 500 * (d - e),
        a = 200 * (e - f);
    return [g, h, a];
  }, R.lab.xyz = function (c) {
    var d = c[0],
        e = c[1],
        a = c[2];
    var b, f, g;
    f = (d + 16) / 116, b = e / 500 + f, g = f - a / 200;
    var h = Math.pow(f, 3),
        i = Math.pow(b, 3),
        j = Math.pow(g, 3);
    return f = .008856 < h ? h : (f - 16 / 116) / 7.787, b = .008856 < i ? i : (b - 16 / 116) / 7.787, g = .008856 < j ? j : (g - 16 / 116) / 7.787, b *= 95.047, f *= 100, g *= 108.883, [b, f, g];
  }, R.lab.lch = function (d) {
    var e = d[0],
        f = d[1],
        a = d[2];
    var b;
    var g = Math.atan2(a, f);
    b = 360 * g / 2 / F, 0 > b && (b += 360);
    var i = Math.sqrt(f * f + a * a);
    return [e, i, b];
  }, R.lch.lab = function (d) {
    var e = d[0],
        f = d[1],
        c = d[2],
        g = 2 * (c / 360) * F,
        h = f * Math.cos(g),
        a = f * Math.sin(g);
    return [e, h, a];
  }, R.rgb.ansi16 = function (a) {
    var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var _a4 = _slicedToArray(a, 3),
        d = _a4[0],
        e = _a4[1],
        f = _a4[2];

    var b = null === c ? R.rgb.hsv(a)[2] : c;
    if (b = J(b / 50), 0 === b) return 30;
    var g = 30 + (J(f / 255) << 2 | J(e / 255) << 1 | J(d / 255));
    return 2 === b && (g += 60), g;
  }, R.hsv.ansi16 = function (a) {
    return R.rgb.ansi16(R.hsv.rgb(a), a[2]);
  }, R.rgb.ansi256 = function (a) {
    var c = a[0],
        d = a[1],
        e = a[2];
    if (c === d && d === e) return 8 > c ? 16 : 248 < c ? 231 : J(24 * ((c - 8) / 247)) + 232;
    var b = 16 + 36 * J(5 * (c / 255)) + 6 * J(5 * (d / 255)) + J(5 * (e / 255));
    return b;
  }, R.ansi16.rgb = function (a) {
    var c = a % 10;
    if (0 == c || 7 == c) return 50 < a && (c += 3.5), c = 255 * (c / 10.5), [c, c, c];
    var d = .5 * (~~(50 < a) + 1),
        e = 255 * ((1 & c) * d),
        f = 255 * ((1 & c >> 1) * d),
        g = 255 * ((1 & c >> 2) * d);
    return [e, f, g];
  }, R.ansi256.rgb = function (a) {
    if (232 <= a) {
      var _b4 = 10 * (a - 232) + 8;

      return [_b4, _b4, _b4];
    }

    a -= 16;
    var c;
    var d = 255 * (G(a / 36) / 5),
        e = 255 * (G((c = a % 36) / 6) / 5),
        f = 255 * (c % 6 / 5);
    return [d, e, f];
  }, R.rgb.hex = function (a) {
    var b = ((255 & J(a[0])) << 16) + ((255 & J(a[1])) << 8) + (255 & J(a[2])),
        c = b.toString(16).toUpperCase();
    return "000000".substring(c.length) + c;
  }, R.hex.rgb = function (a) {
    var b = a.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!b) return [0, 0, 0];
    var c = b[0];
    3 === b[0].length && (c = c.split("").map(function (a) {
      return a + a;
    }).join(""));
    var d = parseInt(c, 16);
    return [255 & d >> 16, 255 & d >> 8, 255 & d];
  }, R.rgb.hcg = function (a) {
    var c = a[0] / 255,
        d = a[1] / 255,
        e = a[2] / 255,
        b = H(H(c, d), e),
        f = I(I(c, d), e),
        g = b - f;
    var h, i;
    return h = 1 > g ? f / (1 - g) : 0, i = 0 >= g ? 0 : b === c ? (d - e) / g % 6 : b === d ? 2 + (e - c) / g : 4 + (c - d) / g + 4, i /= 6, i %= 1, [360 * i, 100 * g, 100 * h];
  }, R.hsl.hcg = function (a) {
    var b = a[1] / 100,
        d = a[2] / 100,
        e = .5 > d ? 2 * b * d : 2 * b * (1 - d);
    var c = 0;
    return 1 > e && (c = (d - .5 * e) / (1 - e)), [a[0], 100 * e, 100 * c];
  }, R.hsv.hcg = function (a) {
    var b = a[1] / 100,
        d = a[2] / 100,
        e = b * d;
    var c = 0;
    return 1 > e && (c = (d - e) / (1 - e)), [a[0], 100 * e, 100 * c];
  }, R.hcg.rgb = function (a) {
    var b = a[0] / 360,
        d = a[1] / 100,
        c = a[2] / 100;
    if (0 === d) return [255 * c, 255 * c, 255 * c];
    var e = [0, 0, 0],
        f = 6 * (b % 1),
        g = f % 1,
        h = 1 - g;
    var i = 0;

    switch (G(f)) {
      case 0:
        e[0] = 1, e[1] = g, e[2] = 0;
        break;

      case 1:
        e[0] = h, e[1] = 1, e[2] = 0;
        break;

      case 2:
        e[0] = 0, e[1] = 1, e[2] = g;
        break;

      case 3:
        e[0] = 0, e[1] = h, e[2] = 1;
        break;

      case 4:
        e[0] = g, e[1] = 0, e[2] = 1;
        break;

      default:
        e[0] = 1, e[1] = 0, e[2] = h;
    }

    return i = (1 - d) * c, [255 * (d * e[0] + i), 255 * (d * e[1] + i), 255 * (d * e[2] + i)];
  }, R.hcg.hsv = function (a) {
    var b = a[1] / 100,
        c = a[2] / 100,
        d = b + c * (1 - b);
    var e = 0;
    return 0 < d && (e = b / d), [a[0], 100 * e, 100 * d];
  }, R.hcg.hsl = function (a) {
    var b = a[1] / 100,
        c = a[2] / 100,
        d = c * (1 - b) + .5 * b;
    var e = 0;
    return 0 < d && .5 > d ? e = b / (2 * d) : .5 <= d && 1 > d && (e = b / (2 * (1 - d))), [a[0], 100 * e, 100 * d];
  }, R.hcg.hwb = function (a) {
    var b = a[1] / 100,
        c = a[2] / 100,
        d = b + c * (1 - b);
    return [a[0], 100 * (d - b), 100 * (1 - d)];
  }, R.hwb.hcg = function (a) {
    var d = a[1] / 100,
        e = a[2] / 100,
        b = 1 - e,
        f = b - d;
    var c = 0;
    return 1 > f && (c = (b - f) / (1 - f)), [a[0], 100 * f, 100 * c];
  }, R.apple.rgb = function (a) {
    return [255 * (a[0] / 65535), 255 * (a[1] / 65535), 255 * (a[2] / 65535)];
  }, R.rgb.apple = function (a) {
    return [65535 * (a[0] / 255), 65535 * (a[1] / 255), 65535 * (a[2] / 255)];
  }, R.gray.rgb = function (a) {
    return [255 * (a[0] / 100), 255 * (a[0] / 100), 255 * (a[0] / 100)];
  }, R.gray.hsl = function (a) {
    return [0, 0, a[0]];
  }, R.gray.hsv = R.gray.hsl, R.gray.hwb = function (a) {
    return [0, 100, a[0]];
  }, R.gray.cmyk = function (a) {
    return [0, 0, 0, a[0]];
  }, R.gray.lab = function (a) {
    return [a[0], 0, 0];
  }, R.gray.hex = function (a) {
    var b = 255 & J(255 * (a[0] / 100)),
        c = ((b << 16) + (b << 8) + b).toString(16).toUpperCase();
    return "000000".substring(c.length) + c;
  }, R.rgb.gray = function (a) {
    var b = (a[0] + a[1] + a[2]) / 3;
    return [100 * (b / 255)];
  };

  var T = function T(a) {
    var b = x(a),
        c = {},
        d = Object.keys(b);

    for (var _e4 = d.length, _f3 = 0; _f3 < _e4; _f3++) {
      var _a5 = d[_f3],
          _e5 = b[_a5];
      null !== _e5.parent && (c[_a5] = z(_a5, b));
    }

    return c;
  };

  var U = {},
      V = Object.keys(S);
  V.forEach(function (a) {
    U[a] = {}, Object.defineProperty(U[a], "channels", {
      value: S[a].channels
    }), Object.defineProperty(U[a], "labels", {
      value: S[a].labels
    });
    var b = T(a),
        c = Object.keys(b);
    c.forEach(function (c) {
      var d = b[c];
      U[a][c] = B(d), U[a][c].raw = A(d);
    });
  });

  var W = U,
      X = function X(a, b) {
    for (var c = -1, d = b.length, e = a.length; ++c < d;) {
      a[e + c] = b[c];
    }

    return a;
  },
      Y = "undefined" == typeof globalThis ? "undefined" == typeof window ? "undefined" == typeof global ? "undefined" == typeof self ? {} : self : global : window : globalThis,
      Z = "object" == typeof Y && Y && Y.Object === Object && Y,
      $ = "object" == typeof self && self && self.Object === Object && self,
      _ = Z || $ || Function("return this")(),
      aa = _.Symbol,
      ba = aa,
      ca = Object.prototype,
      da = ca.hasOwnProperty,
      ea = ca.toString,
      fa = ba ? ba.toStringTag : void 0,
      ga = function ga(a) {
    var b = da.call(a, fa),
        c = a[fa];

    try {
      a[fa] = void 0;
      var d = !0;
    } catch (a) {}

    var e = ea.call(a);
    return d && (b ? a[fa] = c : delete a[fa]), e;
  },
      ha = Object.prototype,
      ia = ha.toString,
      ja = function ja(a) {
    return ia.call(a);
  },
      ka = ba ? ba.toStringTag : void 0,
      la = C,
      ma = function ma(a) {
    return null != a && "object" == typeof a;
  },
      na = function na(a) {
    return ma(a) && la(a) == "[object Arguments]";
  },
      oa = Object.prototype,
      pa = oa.hasOwnProperty,
      qa = oa.propertyIsEnumerable,
      ra = na(function () {
    return arguments;
  }()) ? na : function (a) {
    return ma(a) && pa.call(a, "callee") && !qa.call(a, "callee");
  },
      sa = Array.isArray,
      ta = sa,
      ua = ba ? ba.isConcatSpreadable : void 0,
      va = function va(a) {
    return ta(a) || ra(a) || !!(ua && a && a[ua]);
  },
      wa = function wa(a) {
    var b = null == a ? 0 : a.length;
    return b ? D(a, 1) : [];
  },
      xa = function xa(a) {
    var b = a.indexOf("(") + 1,
        c = a.indexOf(")"),
        d = a.substring(b, c);
    return d.split(",").map(function (a) {
      return parseFloat(a);
    });
  },
      ya = function ya(a) {
    return a.map(function (a) {
      return parseFloat(a);
    });
  },
      za = function za(a) {
    return "string" == typeof a || !ta(a) && ma(a) && la(a) == "[object String]";
  },
      Aa = function Aa(a, b, c) {
    return a >= I(b, c) && a < H(b, c);
  },
      Ba = function Ba(a) {
    var b = typeof a;
    return null != a && ("object" == b || "function" == b);
  },
      Ca = function Ca(a) {
    return "symbol" == typeof a || ma(a) && la(a) == "[object Symbol]";
  },
      Da = 0 / 0,
      Ea = /^\s+|\s+$/g,
      Fa = /^[-+]0x[0-9a-f]+$/i,
      Ga = /^0b[01]+$/i,
      Ha = /^0o[0-7]+$/i,
      Ia = parseInt,
      Ja = function Ja(a) {
    if ("number" == typeof a) return a;
    if (Ca(a)) return Da;

    if (Ba(a)) {
      var b = "function" == typeof a.valueOf ? a.valueOf() : a;
      a = Ba(b) ? b + "" : b;
    }

    if ("string" != typeof a) return 0 === a ? a : +a;
    a = a.replace(Ea, "");
    var c = Ga.test(a);
    return c || Ha.test(a) ? Ia(a.slice(2), c ? 2 : 8) : Fa.test(a) ? Da : +a;
  },
      Ka = 1 / 0,
      La = function La(a) {
    if (!a) return 0 === a ? a : 0;

    if (a = Ja(a), a === Ka || a === -Ka) {
      var b = 0 > a ? -1 : 1;
      return 1.7976931348623157e+308 * b;
    }

    return a === a ? a : 0;
  },
      Ma = function Ma(a, b, c) {
    return b = La(b), void 0 === c ? (c = b, b = 0) : c = La(c), a = Ja(a), Aa(a, b, c);
  },
      Na = function Na(a) {
    return !!(Array.isArray(a) && 3 === a.length) && a.every(function (a) {
      return 0 <= a && 255 >= a;
    });
  },
      Oa = function Oa(a) {
    var b = a.map(function (a) {
      return a;
    }),
        c = p(b, 3),
        d = c[0],
        e = c[1],
        f = c[2];
    return !!(Array.isArray(a) && 3 === a.length) && !!Ma(d, 0, 361) && !!Ma(parseFloat(e), 0, 101) && !!Ma(parseFloat(f), 0, 101) && [e, f].every(function (a) {
      return za(a) && a.includes("%");
    });
  },
      Pa = function Pa(a) {
    return za(a) && a.startsWith("#");
  },
      Qa = function Qa(a) {
    return za(a) && a.startsWith("rgb(");
  },
      Ra = function Ra(a) {
    return za(a) && a.startsWith("hsl(");
  },
      Sa = function Sa(a) {
    return za(a) && !/[^a-zA-Z]/.test(a);
  },
      Ta = function Ta(a) {
    if (Pa(a)) return W.hex.rgb(a.substring(1));
    if (Qa(a)) return xa(a);
    if (Ra(a)) return W.hsl.rgb(xa(a));
    if (Sa(a)) return W.keyword.rgb(a);
    if (Oa(a)) return W.hsl.rgb(ya(a));
    if (Na(a)) return a;
    throw new Error("unable to convert to rgb: ".concat(a));
  },
      Ua = function (a) {
    function b(a) {
      var d;
      return c(this, b), d = o(this, j(b).call(this, a)), d.transitionType = a.transitionType || "parallel", d.rgbGradients = E(a.gradients, d.transitionType), d.gradientType = a.gradientType || "linear", d.angle = "radial" === d.gradientType ? "" : "".concat(a.angle || "0deg", ", "), d.property = O(a.property || "background"), d.duration = a.duration || 5e3, d.element = a.element || "div", d.style = f({}, d.property, ""), d.cycleConstants = t(d.rgbGradients, d.transitionType), d.lastCycle = d.rgbGradients.length - 1, d.isText = "text" === a.property, d.animationId = 0, d.mounted = !1, d.elapsed = 0, d.updateState = d.updateState.bind(n(d)), d.animate = d.animate.bind(n(d)), d.state = {
        currentCycle: 0,
        counter: 0
      }, d;
    }

    return i(b, a), e(b, [{
      key: "componentDidMount",
      value: function value() {
        this.mounted = !0, this.animate();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.mounted = !1, window.cancelAnimationFrame(this.animationId);
      }
    }, {
      key: "updateState",
      value: function value(a) {
        this.setState(h({}, a));
      }
    }, {
      key: "animate",
      value: function value(a) {
        if (this.mounted) {
          var b = this.state,
              c = b.currentCycle,
              d = b.counter,
              e = this.cycleConstants[c],
              f = e.sourceGradient,
              g = e.leftDelta,
              h = e.rightDelta;
          this.style[this.property] = u({
            gradientType: this.gradientType,
            duration: this.duration,
            property: this.property,
            angle: this.angle,
            sourceGradient: f,
            rightDelta: h,
            leftDelta: g,
            counter: d
          }), this.isText && (this.style.WebkitBackgroundClip = "text", this.style.WebkitTextFillColor = "transparent");
          var i = J(a - this.elapsed) || 16,
              j = d >= this.duration ? 0 : d + i,
              k = c === this.lastCycle ? 0 : c + 1;
          0 === j ? this.updateState({
            currentCycle: k,
            counter: j
          }) : this.updateState({
            counter: j
          }), this.elapsed = a, this.animationId = window.requestAnimationFrame(this.animate);
        }
      }
    }, {
      key: "render",
      value: function value() {
        var a = this.props,
            b = a.transitionType,
            c = a.className,
            d = void 0 === c ? "" : c,
            e = a.gradientType,
            f = a.style,
            g = void 0 === f ? {} : f,
            i = a.gradients,
            j = a.children,
            k = a.duration,
            l = a.property,
            n = a.element,
            o = a.angle,
            p = m(a, ["transitionType", "className", "gradientType", "style", "gradients", "children", "duration", "property", "element", "angle"]);
        return K.createElement(this.element, h({}, p, {
          className: "react-gradient ".concat(d),
          style: h({}, g, {}, this.style)
        }), j);
      }
    }]), b;
  }(b.Component);

  a.Gradient = Ua, Object.defineProperty(a, "__esModule", {
    value: !0
  });
});